import { PolygonIcon, TrashIcon } from "@/assets/icons";

import { Button } from "equator-design-system";

interface DrawPolygonFormProps {
  onDraw: () => void;
  mapImg?: string;
  onDelete: () => void;
}

export const DrawPolygonForm = ({
  onDraw,
  mapImg,
  onDelete
}: DrawPolygonFormProps) => {
  return (
    <div className="flex flex-col gap-2 justify-center items-center w-full min-h-52 border border-whisper rounded-md">
      {mapImg && (
        <div className="relative">
          <img
            src={mapImg}
            alt="Map"
            className="w-full h-full object-cover rounded-md"
          />
          <button
            type="button"
            className="absolute top-2 right-2 cursor-pointer bg-white rounded-lg p-2"
            onClick={onDelete}
            aria-label="button-delete-image-map"
          >
            <TrashIcon className="w-6 h-6" />
          </button>
        </div>
      )}
      {!mapImg && (
        <>
          <PolygonIcon className="fill-teal-500" />
          <Button
            variant="secondary"
            className="btn-secondary text-sm font-semibold"
            type="button"
            onClick={onDraw}
          >
            <span>Custom polygon</span>
          </Button>
          <span className="text-xs">You will be redirected to Map Editor</span>
        </>
      )}
    </div>
  );
};
